import { render, staticRenderFns } from "./FormInputGroupBasic.vue?vue&type=template&id=57705b84&"
import script from "./FormInputGroupBasic.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports